import apiClient, { setAuthToken } from './api.client';

const ensureAuth = () => {
  const tk = localStorage.getItem('token');
  if (tk) setAuthToken(tk);
};

const handleError = (err) => {
  if (err?.response?.status === 401) {
    const e = new Error('Unauthorized');
    e.status = 401;
    throw e;
  }
  throw err;
};

const withAccount = (accountId) => (accountId ? { params: { accountId } } : undefined);

const PrintService = {
  getStatus: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get('/print/status', withAccount(accountId));
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getCredentials: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get('/print/credentials', withAccount(accountId));
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  updateConfig: async (accountId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.patch('/print/config', data, withAccount(accountId));
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  createJob: async (accountId, { orderId, target }) => {
    try {
      ensureAuth();
      const res = await apiClient.post(
        '/print/jobs',
        { orderId, target },
        withAccount(accountId),
      );
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
};

export default PrintService;
